// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';

import ArrayUtils from '../../utils/ArrayUtils';
import OrderViewUtils from '../../utils/OrderViewUtils';

// -- views
import LocalizableSelect from './LocalizableSelect';

export default class OrderModeChooser extends Component {

  static defaultProps = {
    clearable: true,

    readOnly: false,

    multi: false,

    values: [],

    value: null,

    placeholder: "",
  };

  static propTypes = {
    placeholder: PropTypes.string,

    values: PropTypes.array,

    value: PropTypes.string,

    multi: PropTypes.bool,

    // param: number, the chosen vat
    onChange: PropTypes.func.isRequired,

    clearable: PropTypes.bool,

    readOnly: PropTypes.bool,

    /**
     * The modes to propose
     */
    modes: PropTypes.arrayOf(PropTypes.number).isRequired,
  };

  onSelect = (options: SelectOption | SelectOptions) => {
    if (this.props.multi) {
      const modes: Array<OrderMode> = options.map((option: SelectOption) => {
        return option.value;
      });

      this.props.onChange(modes);
    } else {
      if (_.isNull(options)) {
        this.props.onChange(null);
      } else {
        this.props.onChange(options.value);
      }
    }
  };

  render() {
    const values = !_.isNull(this.props.value) ? [ this.props.value ] : this.props.values;

    const selectValues: SelectOptions = [];
    const options: SelectOptions = this.props.modes.map((mode: string) => {
      const option: SelectOption = {
        label: OrderViewUtils.getLabelForMode(mode),
        value: mode,
      };

      const found = ArrayUtils.exists(values, (value: OrderMode) => {
        return value === mode;
      });
      if (found) {
        selectValues.push(option);
      }

      return option;
    });

    return (
      <div className="order_mode_chooser">
        <LocalizableSelect
          placeholder={this.props.placeholder}
          name="action"
          value={!this.props.multi && !_.isEmpty(selectValues) ? selectValues[0].value : (_.isEmpty(selectValues) ? null : selectValues)}
          options={options}
          onChange={this.onSelect}
          clearable={this.props.clearable}
          disabled={this.props.readOnly}
          multi={this.props.multi}
        />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/OrderModeChooser.js